import { useEffect } from 'react';
import { Card, LoadingMochi } from '@autopass-web/mochi-component';
import styles from './index.module.sass';
import { RECEIPT_TYPES, loadJson, useInterval } from '@autopass-web/domain';
import BarcodePaymentDialog from './barcode-payment-dialog';
import { analytics, storage } from '../../app-loader';
import Hint from './hint';
import useStore from './store';
import useAppStore from '../../app-store';
import ReceiptCard from './receipt-card';
import ScanReceiptCard from './scan-receipt-card';
import ScanCodeCard from './scan-code-card';
import SuccessCard from './success-card';

let loveCodeList = [];

export const barcodeScanReceipt = [
  RECEIPT_TYPES.CARRIER_MOBILE_BARCODE,
  RECEIPT_TYPES.CARRIER_CITIZEN_DIGITAL,
  RECEIPT_TYPES.DONATE,
];

export const getReceiptData = () => {
  const appStore = useAppStore();
  const receipt = appStore.user?.receipt;
  let result = {};

  switch (receipt?.type) {
    case RECEIPT_TYPES.CARRIER_MEMBER:
      result = {
        name: '會員載具',
        value: '請記得現場與站員索取發票。',
      };
      break;
    case RECEIPT_TYPES.CARRIER_MOBILE_BARCODE:
      result = {
        name: '手機條碼載具',
        value: receipt.barcode,
      };
      break;
    case RECEIPT_TYPES.DONATE:
      result = {
        name: '捐贈愛心碼載具',
        value: receipt.loveCode,
      };
      break;
    case RECEIPT_TYPES.B2B:
      result = {
        name: '三聯式電子發票',
        value: `請與站員告知開立統編「${receipt.ubn}」`,
      };
      break;
    case RECEIPT_TYPES.CARRIER_CITIZEN_DIGITAL:
      result = {
        name: '自然人憑證載具',
        value: receipt.citizenDigitalNumber,
      };
      break;
    default:
      break;
  }

  result = { ...result, type: receipt?.type };

  return result;
};

const BarcodePayment = () => {
  const store = useStore();
  const appStore = useAppStore();
  const receiptData = getReceiptData();

  useEffect(() => {
    loadJson('/json/love_code.json').then((data) => {
      loveCodeList = data;
    });
  }, []);

  useEffect(() => {
    store.setReceiptBarcodeHide(
      storage.getBarcodePaymentReceiptCodeHiddenState(),
    );

    document.body.style.touchAction = 'none';
    document.body.style.overflow = 'hidden';

    const init = async () => {
      await store.fetchBarcodePaymentData(() => {
        analytics.barcode_payment_pageview();
        store.fetchBoards();
      });
      if (receiptData.type === RECEIPT_TYPES.DONATE) {
        let resultData = loveCodeList.find(
          (data) => data.love_code === receiptData.value,
        );
        store.setDonateData(resultData);
      }
    };

    init();

    return () => {
      document.body.style.touchAction = 'inherit';
      document.body.style.overflow = 'inherit';
      store.setBarcodePaymentResult(null);
    };
  }, []);

  useEffect(() => {
    if (store.barcodePaymentResult === null) return;

    if (store.barcodePaymentResult.error) {
      console.log(store.barcodePaymentResult.error);
      store.setBarcodeCountdown(false);
      store.setBarcodePaymentDialog({
        type: 'payment_fail',
        content:
          appStore.app === 'enterprise-driver'
            ? '交易授權失敗，可能為錢包餘額不足、或連線異常所致，請改用現場付款方式付款，並開立原公司統編。'
            : store.barcodePaymentResult.error.message,
      });
    }

    resetCountdown();
  }, [store.barcodePaymentResult]);

  useInterval(
    () => {
      if (store.scanCountdownTime > 10) {
        resetCountdown();
        store.setBarcodePaymentDialog({
          type: 'payment_timeout',
        });
      } else {
        store.setBarcodeCountdownTime((prev) => prev + 1);
      }
    },
    store.barcodeCountdown ? 1000 : null,
  );

  const resetCountdown = () => {
    store.setBarcodeCountdown(false);
    store.setBarcodeCountdownTime(0);
  };

  return (
    <>
      <LoadingMochi show={store.barcodeCountdown} />
      <BarcodePaymentDialog
        data={store.barcodePaymentDialog}
        setData={store.setBarcodePaymentDialog}
        globalAction={store.globalAction}
      />
      <div className={styles.container}>
        <MainContent />
      </div>
    </>
  );
};

const MainContent = () => {
  const appStore = useAppStore();
  const store = useStore();
  const isPaymentSuccess =
    store.barcodePaymentResult !== null &&
    store.barcodePaymentResult.status === 'success';
  if (isPaymentSuccess) return <SuccessCard />;

  if (appStore.defaultReceipt) {
    const Text = () => {
      switch (appStore.defaultReceipt.type) {
        case RECEIPT_TYPES.B2B:
          return '發票請開立統編';
        default:
          return '';
      }
    };
    return (
      <>
        <Card className={styles['default-receipt-card']}>
          <span>
            <Text />
          </span>
          <br />
          <span>{appStore.defaultReceipt.value}</span>
        </Card>
        <ScanCodeCard />
      </>
    );
  }

  return (
    <>
      <ScanReceiptCard />
      <ScanCodeCard />
      <ReceiptCard />
      <Hint />
    </>
  );
};

export default BarcodePayment;
